import { LegalLayout } from '../../components/LegalLayout';
import { t } from '../../hooks/useT';
import { LegalBody } from './LegalBodies';

export function ConfidentialitePage() {
  return (
    <LegalLayout title={t('legal.privacy.title')} lead={t('legal.privacy.lead')}>
      <LegalBody page="privacy" />
    </LegalLayout>
  );
}
